import ActionSplitDropdown from './ActionSplitDropdown.connect';

export default ActionSplitDropdown;
